// @flow @jsx h

/* eslint-disable compat/compat */

import { toArray } from 'array'
import bem from 'bem'
import { Component, h } from 'preact'
import style from './index.css'

type Props = {
  className?: string,
  id: string,
  backgrounds: any[],
  sections: any[],
  margin?: string,
  onAnalyticsEvent?: Function,
  viewport: any
}

type State = {
  didView: boolean,
  visibleIndex: number
}

class ScrollSlideshow extends Component<Props, State> {
  elm: HTMLDivElement
  intersectionObserver: IntersectionObserver | null
  triggerElms: HTMLElement[]
  sectionsElm: HTMLDivElement

  constructor () {
    super()

    this.state = {
      didView: false,
      visibleIndex: 0
    }

    this.triggerElms = []
  }

  componentDidMount () {
    const sectionElms = []

    const intersectionObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const idx = sectionElms.indexOf(entry.target)

          if (entry.isIntersecting) {
            if (!this.state.didView && this.props.onAnalyticsEvent) {
              this.props.onAnalyticsEvent({
                action: `scrollSlideshow/VIEW/${this.props.id}`
              })

              this.setState({ didView: true, visibleIndex: idx })
            } else {
              this.setState({ visibleIndex: idx })
            }
          }
        })
      },
      {
        rootMargin: this.props.margin || '0px 0px 0px 0px',
        threshold: 0
      }
    )

    toArray(this.sectionsElm.childNodes).forEach(sectionElm => {
      sectionElms.push(sectionElm.firstChild)
      intersectionObserver.observe(sectionElm.firstChild)
    })

    this.intersectionObserver = intersectionObserver
  }

  componentWillUnmount () {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect()
      this.intersectionObserver = null
    }
  }

  render () {
    const { backgrounds, sections, viewport } = this.props
    const className = `${style.scrollSlideshow}${
      this.props.className ? ` ${this.props.className}` : ''
    }`
    const { visibleIndex } = this.state

    const backgroundsInlineStyle = {}
    const backgroundInlineStyle = {}

    if (viewport.height > -1) {
      backgroundsInlineStyle.height = `${viewport.height}px`
      backgroundInlineStyle.height = `${viewport.height}px`
    }

    return (
      <div ref={elm => (this.elm = elm)} className={className}>
        <div
          className={style.scrollSlideshow__backgrounds}
          style={backgroundsInlineStyle}
        >
          {backgrounds.map((background, idx) => (
            <div
              key={String(idx)}
              className={bem(
                style.scrollSlideshow__background,
                idx === visibleIndex && 'visible'
              )}
              style={backgroundInlineStyle}
            >
              {background}
            </div>
          ))}
        </div>
        <div
          ref={sectionsElm => (this.sectionsElm = sectionsElm)}
          className={style.scrollSlideshow__sections}
        >
          {sections}
        </div>
      </div>
    )
  }
}

export default ScrollSlideshow



// WEBPACK FOOTER //
// ./src/lib/@nrk/dh-feature-components/ScrollSlideshow/index.js